module.exports = __webpack_public_path__ + "media/typy/ciezarowe@3x-b98e445a.svg";